import React, { useState } from "react";
import {
  Button,
  Container
} from "reactstrap";
import OtpInput from '../../components/OtpInput/IndexOtpInput';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { otpSend, otpResend, otpVerify, register, checkExit, addEvaluation } from '../../actions'
import { registerByAdministrator } from "actions/registerAction";

// valid
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const RegisterSchema = Yup.object().shape({
  firstName: Yup.string() //ประเภทของข้อมูลคือ String
    .min(2, 'ชื่อสั้นเกินไป!') //ต้องมีอย่างน้อย 2 ตัวอักษรขึ้นไป
    .max(50, 'ชื่อยาวเกินไป!') //สูงสุด 50 ตัวอักษร
    .required('ต้องกรอกนามสกุล'), //ต้องกรอกช่องนี้
  lastName: Yup.string() //ประเภทของข้อมูลคือ String
    .min(2, 'นามสกุลสั้นเกินไป!') //ต้องมีอย่างน้อย 2 ตัวอักษรขึ้นไป
    .max(50, 'นามสกุลยาวเกินไป!') //สูงสุด 50 ตัวอักษร
    .required('ต้องกรอกนามสกุล'), //ต้องกรอกช่องนี้
  password: Yup.string() //ประเภทของข้อมูลคือ String
    .min(6, 'ต้องมีอักษร 6 ตัวขึ้นไป') //ต้องมีอย่างน้อย 3 ตัวอักษรขึ้นไป
    .required('ต้องกรอกรหัสผ่าน') //ต้องกรอกช่องนี้
    .matches('^(?=.*[a-z])(?=.*[A-Z]).{6,}$', 'กรุณากรอกอย่างน้อย 6 ตัวอักษร (ภาษาอังกฤษตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่)'),
  confirmPassword: Yup.string() //ประเภทของข้อมูลคือ String
    .min(3, 'ต้องมีอักษร 3 ตัวขึ้นไป') //ต้องมีอย่างน้อย 3 ตัวอักษรขึ้นไป
    .required('ต้องยืนยันรหัสผ่าน') //ต้องกรอกช่องนี้
    //ตรวจสอบว่า password match หรือไม่
    .test('passwords-match', 'รหัสผ่านไม่ตรงกัน', function (value) {
      return this.parent.password === value;
    }),
  mobile: Yup.string()
    .required("ต้องระบุหมายเลขโทรศัพท์")
    .matches(phoneRegExp, 'กรอกข้อมูลไม่ถูกต้อง')
    .min(10, "เบอร์โทรศัพท์เคลื่อนที่ สั้นเกินไป")
    .max(10, "เบอร์โทรศัพท์เคลื่อนที่ ยาวเกินไป")
    .test('mobile-can-use', 'ไม่สามารถใช้หมายเลขนี้ได้', function (value) {
        return checkExit(value).then(res => {
          if (res.length > 0) {
            return false
          } else {
            return true
          }
        })
    }),
});

// core components
function AddUser({
  userType,
  token,
  onSuccess
}) {

  const [otpCode, setOtpCode] = useState(null)
  const [otpRef, setOtpRef] = useState(null)
  const [otpShow, setOtpShow] = useState(false)
  const [isOtpVerify, setIsOtpVerify] = useState(false)
  const [otpTimeOut, setOtpTimeOut] = useState(null)
  const [otpButtonDisable, setOtpButtonDisable] = useState(false)
  const [otpErrorMessage, setOtpErrorMessage] = useState('')

  const [mobileNo, setMobileNo] = useState('')

  const isNumber = (text) => {
    let value = '';
    let valid = false;
    let numbers = '0123456789';
    for (var i = 0; i < text.length; i++) {
      if (numbers.indexOf(text[i]) > -1) {
        value = value + text[i];
        valid = true
      }
      else {
        valid = false
      }
    }
    return { value, valid }

  }

  

  

  const _onSubmit = (data,token) => {
    
    data.Username = data.mobile;
    data.personType = userType;

    registerByAdministrator(data,token).then((res) => {
      if (res) {
        var index = res.toString().indexOf("Error:")
        if (index == -1) {
          
          onSuccess(true)
          
        } else {
          onSuccess(false)
        }
      } else {
        onSuccess(false)
      }
    }).catch((error) => {

    })
  }

  return (
    <Container>
      <div>
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            password: '',
            confirmPassword: '',
            mobile: '',
            Username: ''
          }}
          validationSchema={RegisterSchema}
          onSubmit={(e) => _onSubmit(e,token)}
        >
          {({ errors, touched, handleSubmit, handleReset, setFieldValue }) => (
            <Form onSubmit={handleSubmit} onReset={handleReset}>
              <div className="form-group">
                <label htmlFor="firstName" >
                  ชื่อ
                             </label>
                <Field
                  name="firstName"
                  type="text"
                  className={`form-control ${touched.firstName ? errors.firstName ? 'is-invalid' : 'is-valid' : ''}`}
                  id="firstName"
                  placeholder="Enter First name"
                />
                <ErrorMessage component="div" name="firstName" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="lastName" >
                  นามสกุล
                             </label>
                <Field
                  name="lastName"
                  type="text"
                  className={`form-control ${touched.lastName ? errors.lastName ? 'is-invalid' : 'is-valid' : ''}`}
                  id="lastName"
                  placeholder="Enter Last Name"
                />
                <ErrorMessage component="div" name="lastName" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="password" >
                  รหัสผ่าน
                              </label>
                <Field
                  name="password"
                  type="password"
                  className={`form-control ${touched.password ? errors.password ? 'is-invalid' : 'is-valid' : ''}`}
                  id="password"
                  placeholder="Password"
                />
                <ErrorMessage component="div" name="password" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword" >
                  ยืนยันรหัสผ่าน
                              </label>
                <Field
                  name="confirmPassword"
                  type="password"
                  className={`form-control ${touched.confirmPassword ? errors.confirmPassword ? 'is-invalid' : 'is-valid' : ''}`}
                  id="confirmPassword"
                  placeholder="Enter Confirm Password"
                />
                <ErrorMessage component="div" name="confirmPassword" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="lastName" >
                  เบอร์โทรศัพท์มือถือ (Username เข้าใช้ระบบ)
                             </label>
                <Field
                  name="mobile"
                  type="text"
                  className={`form-control ${touched.mobile ? errors.mobile ? 'is-invalid' : 'is-valid' : ''}`}
                  id="mobile"
                  onChange={e => {

                    e.preventDefault();
                    const { value } = e.target;
                    if (value.length < 11) {
                      const mobileNo = isNumber(value)
                      setFieldValue("mobile", mobileNo.value);
                      setMobileNo(mobileNo.value)
                    }
                  }}
                  placeholder="Enter Mobile Phone No"
                />
                <ErrorMessage component="div" name="mobile" className="invalid-feedback" />
              </div>
             
              <div className="row">
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <Button type="submit" className="btn-round" color="info" style={{ width: '80%' }}>เพิ่มผู้ใช้งาน</Button>
                </div>
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <Button type="reset" className="btn-round" color="primary" style={{ width: '50%' }}>ล้างค่า</Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}

export default AddUser;
